import { Text } from '@sitecore-jss/sitecore-jss-react';
import { useEffect, useState } from 'react';
import YouTube from 'react-youtube';
import LazyImage from 'src/components/Common/LazyImage';
import SvgLoader from 'src/components/Common/SvgLoader';
import track from 'src/lib/Analytics';
import { YouTubePlayer } from 'youtube-player/dist/types';
import { VideoProps } from './types';

const Video = ({
  closedCaptions,
  autoplay,
  headline,
  modestBranding,
  relatedVideos,
  url,
  image,
  id,
}: VideoProps) => {
  const videoId = url.replace('https://www.youtube.com/embed/', '');
  const playerVars = {
    autoplay,
    cc_load_policy: closedCaptions,
    modestbranding: modestBranding,
    rel: relatedVideos,
  };
  const [player, setPlayer] = useState<null | YouTubePlayer>(null);
  const [hasPlayed, setHasPlayed] = useState(false);
  const [videoEnded, setVideoEnded] = useState(false);

  const handleClick = (videoId: string) => {
    if (player) {
      player.loadVideoById(videoId);
    }
    setHasPlayed(true);
  };

  if (!hasPlayed && player && autoplay === 1) {
    player.mute();
    handleClick(videoId);
  }

  const sendAttribution = (page: string, player: YouTubePlayer | null) => {
    if (player) {
      track.video({
        target: player,
        id,
        page,
      });
    }
  };

  useEffect(() => {
    const page = window.location.pathname || '';
    return () => {
      sendAttribution(page, player);
    };
  }, [player]);

  return (
    <section className="container-4xl py-32 px-16 w-full">
      {headline.value && <Text className="text-2xl mb-24 text-center" field={headline} tag="h2" />}
      <div className="relative max-w-2xl mx-auto">
        {videoEnded && (
          <>
            <button
              className="absolute bg-black w-full h-full z-overlay"
              onClick={() => {
                player?.playVideo();
                setVideoEnded(false);
              }}
              tabIndex={0}
            >
              <div className="relative flex items-center justify-center bg-black bg-opacity-40 rounded-md">
                <LazyImage {...image} className="js-splash-img w-full aspect-16/9 rounded-md" />
                <SvgLoader name="Play" color="text-white" className="absolute" size={64} />
              </div>
            </button>
          </>
        )}
        <YouTube
          videoId={videoId}
          id={id}
          onReady={event => setPlayer(event.target)}
          opts={{ playerVars, width: '', height: '' }}
          onEnd={() => {
            const page = window.location.pathname || '';
            sendAttribution(page, player);
            setVideoEnded(true);
          }}
          title={`Video: ${headline.value}`}
          className="relative overflow-auto bg-gray rounded-md"
          iframeClassName="w-full aspect-16/9 rounded-md"
        />
        {!hasPlayed && image && (
          <button className="absolute inset-0" onClick={() => handleClick(videoId)} tabIndex={0}>
            <div className="relative flex items-center justify-center bg-black bg-opacity-40 rounded-md">
              <LazyImage {...image} className="js-splash-img w-full aspect-16/9 rounded-md" />
              <SvgLoader name="Play" color="text-white" className="absolute" size={64} />
            </div>
          </button>
        )}
      </div>
    </section>
  );
};

export default Video;
